import React from "react";
import PropTypes from "prop-types";

import PopupContentBox from "../../components/PopupContentBox";
import KovaaksLogo from '../../assets/images/logo.svg'
import Input from "../Input";

class PasswordResetBody extends React.Component {
  render() {
    const {
      newPwd,
      confirmPwd,
      error,
      onChangeInput
    } = this.props;

    return (
      <div className="password-form-inner">
        <div className="password-form-header">
          <div className="header-content-wrapper">
            <div className="header-title">
              <span>Enter New Password</span>
            </div>
            <div className="header-subtitle">
              {/* <span>Please enter your email below to reset your password</span> */}
            </div>
          </div>
          <div className="header-logo-wrapper">
            <img src={KovaaksLogo} alt="" className="header-logo" />
          </div>
        </div>
        <div className="password-form-content">
          <PopupContentBox>
            <div className="password-form-content-main">
              <div className="input-group">
                <div className="input-wrapper">
                  <Input
                    autoFocus
                    type="password"
                    id="newPwd"
                    name="newPwd"
                    value={newPwd}
                    placeholder="New password"
                    onChange={onChangeInput}
                  />
                </div>
              </div>
              <div className="input-group">
                <div className="input-wrapper">
                  <Input
                    type="password"
                    id="confirmPwd"
                    name="confirmPwd"
                    value={confirmPwd}
                    placeholder="Confirm password"
                    onChange={onChangeInput}
                  />
                </div>
              </div>
              {error && (
                <div className="error-wrapper form-info">
                  {error}
                </div>
              )}
            </div>
          </PopupContentBox>
        </div>
      </div>
    );
  }
}

PasswordResetBody.propTypes = {
  email: PropTypes.string,
  error: PropTypes.node,
  onChangeInput: PropTypes.func
};

PasswordResetBody.defaultProps = {
  email: "",
  error: null,
  onChangeInput: () => {}
};

export default PasswordResetBody;
